import React from "react";
import { Button } from "../../../components/tailwind/button/Button";

export type TranslationMemoryPaginationBarProps = {
  pageStart: number;
  pageEnd: number;
  totalEntryCount: number;
  pageSize: number;
  onPageSizeChange: (size: number) => void;
  currentPage: number;
  totalPages: number;
  onGoPrev: () => void;
  onGoNext: () => void;
  pageSizeSelectId: string;
  className?: string;
};

export const TranslationMemoryPaginationBar: React.FC<TranslationMemoryPaginationBarProps> = ({
  pageStart,
  pageEnd,
  totalEntryCount,
  pageSize,
  onPageSizeChange,
  currentPage,
  totalPages,
  onGoPrev,
  onGoNext,
  pageSizeSelectId,
  className = "tw-flex tw-items-center tw-justify-between tw-mb-3",
}) => {
  return (
    <div className={className}>
      <div className="tw-text-sm tw-text-gray-500">
        Showing {totalEntryCount === 0 ? 0 : pageStart + 1}-
        {Math.min(pageEnd, totalEntryCount)} of {totalEntryCount}
      </div>
      <div className="tw-flex tw-items-center tw-gap-2">
        <label className="txu-label !tw-m-0" htmlFor={pageSizeSelectId}>
          Rows
        </label>
        <select
          id={pageSizeSelectId}
          className="txu-input !tw-w-auto"
          value={String(pageSize)}
          onChange={(e): void => {
            onPageSizeChange(Number(e.target.value));
          }}
        >
          <option value="50">50</option>
          <option value="100">100</option>
          <option value="200">200</option>
        </select>
        <Button
          type="button"
          content="Prev"
          variant="secondary-alt"
          disabled={currentPage <= 1}
          onClick={onGoPrev}
        />
        <span className="tw-text-sm tw-text-gray-600">
          Page {currentPage} / {totalPages}
        </span>
        <Button
          type="button"
          content="Next"
          variant="secondary-alt"
          disabled={currentPage >= totalPages}
          onClick={onGoNext}
        />
      </div>
    </div>
  );
};
